import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/reactive-forms/services/app-config.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private appConfigService: AppConfigService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(request.method !== 'JSONP'){
    const lang = localStorage.getItem("lang");
    const token = request.url.toUpperCase().
    includes(this.appConfigService.oDataApi.toUpperCase()) ? localStorage.getItem("ODataToken") : localStorage.getItem("jwt");
    var requestHeaders: { [name: string]: string | string[] } = {};
    if(lang){
      let AcceptLanguage;
      if (lang == 'ar') {
          AcceptLanguage = 'ar-EG'
      }
      else {
          AcceptLanguage = 'en-US'
      }
      requestHeaders['Accept-Language'] = `${AcceptLanguage}`;
    }
    if (token) {
      requestHeaders['Authorization'] = `Bearer ${token}`;
    }
    request = request.clone({setHeaders:requestHeaders})
  }
    return next.handle(request);
  }
}